import AddCollaboratorCard from './dashboard-onboarding-cards/collaborate/collab-add-collaborator-card';
import AddVideoToTeamCard from './dashboard-onboarding-cards/collaborate/collab-add-video-to-team-card';
import CustomizeBrandingCard from './dashboard-onboarding-cards/features/feature-customize-branding-card';
import ShareVideoCard from './dashboard-onboarding-cards/how-to-use/how-share-video-card';
import UploadVideoCard from './dashboard-onboarding-cards/how-to-use/how-upload-video-card';
import PersonalLibraryIntroCard from './dashboard-onboarding-cards/intro/personalLibraryIntroCard';
import SharedLibraryIntroCard from './dashboard-onboarding-cards/intro/sharedLibraryIntroCard';
import TeamLibraryIntroCard from './dashboard-onboarding-cards/intro/teamLibraryIntroCard';
import OrganizeFoldersCard from './dashboard-onboarding-cards/organization/organize-folders-card';
import InstallChromeExtensionCard from './dashboard-onboarding-cards/tools/tool-install-chrome-extension-card';
import InstallDesktopAppCard from './dashboard-onboarding-cards/tools/tool-install-desktop-app-card';
import InstalliOSAppCard from './dashboard-onboarding-cards/tools/tool-install-loom-for-ios';
import ExploreTeamLibraryCard, {
  filterFunction as exploreTeamLibraryCardFilterFunction,
} from './dashboard-onboarding-cards/collaborate/collab-explore-team-library-card';
import RecordVideoCard, {
  filterFunction as recordVideoCardFilterFunction,
} from './dashboard-onboarding-cards/how-to-use/how-record-video-card';
import {
  ADD_COLLABORATOR_CARD_KEY,
  ADD_VIDEO_TO_TEAM_CARD_KEY,
  CUSTOMIZE_BRANDING_CARD_KEY,
  EXPLORE_TEAM_LIBRARY_CARD_KEY,
  INSTALL_CHROME_EXTENSION_CARD_KEY,
  INSTALL_DESKTOP_APP_CARD_KEY,
  INSTALL_IOS_APP_CARD_KEY,
  ORGANIZE_FOLDERS_CARD_KEY,
  PERSONAL_LIBRARY_INTRO_CARD,
  RECORD_VIDEO_CARD_KEY,
  SHARE_VIDEO_CARD_KEY,
  SHARED_LIBRARY_INTRO_CARD,
  TEAM_LIBRARY_INTRO_CARD,
  UPLOAD_VIDEO_CARD_KEY,
} from '../../../../../shared/constants/workspaceOnboarding';

export const mapCardKeytoComponent = {
  [PERSONAL_LIBRARY_INTRO_CARD]: PersonalLibraryIntroCard,
  [TEAM_LIBRARY_INTRO_CARD]: TeamLibraryIntroCard,
  [SHARED_LIBRARY_INTRO_CARD]: SharedLibraryIntroCard,
  [ADD_COLLABORATOR_CARD_KEY]: AddCollaboratorCard,
  [ADD_VIDEO_TO_TEAM_CARD_KEY]: AddVideoToTeamCard,
  [CUSTOMIZE_BRANDING_CARD_KEY]: CustomizeBrandingCard,
  [INSTALL_CHROME_EXTENSION_CARD_KEY]: InstallChromeExtensionCard,
  [INSTALL_DESKTOP_APP_CARD_KEY]: InstallDesktopAppCard,
  [INSTALL_IOS_APP_CARD_KEY]: InstalliOSAppCard,
  [ORGANIZE_FOLDERS_CARD_KEY]: OrganizeFoldersCard,
  [RECORD_VIDEO_CARD_KEY]: RecordVideoCard,
  [SHARE_VIDEO_CARD_KEY]: ShareVideoCard,
  [UPLOAD_VIDEO_CARD_KEY]: UploadVideoCard,
  [EXPLORE_TEAM_LIBRARY_CARD_KEY]: ExploreTeamLibraryCard,
};

export const mapCardKeyToCustomFilterFunctions = {
  [EXPLORE_TEAM_LIBRARY_CARD_KEY]: exploreTeamLibraryCardFilterFunction,
  [RECORD_VIDEO_CARD_KEY]: recordVideoCardFilterFunction,
};

export const COMPACT_ONBOARDING_INTRO_CARDS = new Set([
  PERSONAL_LIBRARY_INTRO_CARD,
  TEAM_LIBRARY_INTRO_CARD,
  SHARED_LIBRARY_INTRO_CARD,
]);

export const FULL_CAROUSEL_3_CARD_MAX_WIDTH_BREAKPT = 1439;
export const FULL_CAROUSEL_2_CARD_MAX_WIDTH_BREAKPT = 1163;
export const FULL_CAROUSEL_1_CARD_MAX_WIDTH_BREAKPT = 893;

export const FULL_CAROUSEL_MAX_SIZE = 1116;
export const FULL_CAROUSEL_3_CARD_SIZE = 837;
export const FULL_CAROUSEL_2_CARD_SIZE = 558;
export const FULL_CAROUSEL_1_CARD_SIZE = 279;
